import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { VotingService } from '../../voting/voting.service';

@Injectable({
  providedIn: 'root',
})
export class NavbarActiveElectionService {
  private readonly activeElectionCount$ = new BehaviorSubject<number>(0);

  constructor(private readonly votingService: VotingService) { }

  getActiveElectionCount(): Observable<number> {
    return this.activeElectionCount$.asObservable();
  }

  refreshActiveElectionCount(): void {
    this.votingService.getActiveElectionCount().pipe(
      take(1),
      catchError(() => of(0)),
    ).subscribe((count) => {
      this.activeElectionCount$.next(count);
    });
  }

  notifyActiveElectionDetected(): void {
    this.refreshActiveElectionCount();
  }
}